import {reactive} from 'vue'

export const  store = reactive({
  lang:localStorage.getItem('language') || 'zh_CN',
  setLang(lang) {
    this.lang = lang
    localStorage.setItem('language', lang)
  }
})